import { Toaster } from 'react-hot-toast';

const ToastProvider = () => (
  <Toaster
    position="top-right"
    toastOptions={{
      duration: 4000,
      style: {
        background: '#1f2937',
        color: '#fff',
        borderRadius: '12px',
        fontSize: '14px',
        padding: '12px 16px',
      },
      success: {
        duration: 3000,
        iconTheme: { primary: '#10b981', secondary: '#fff' },
      },
      error: {
        duration: 5000,
        iconTheme: { primary: '#ef4444', secondary: '#fff' },
      },
    }}
  />
);

export default ToastProvider;
